import { CostosPlataformaService } from "../../generated/grpc/plataforma_costos_pb";
import { CostoGanaderiaResponse } from "../../response/costos/CostoGanaderiaResponse";
import { CostoGanaderiaPayload } from "../api/payload/costos/CostoGanaderiaPayload";
import { ServiceSaveBase } from "../base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";
import { CostoGanaderiaListService, toCostoGanaderiaResponse } from "./CostoGanaderiaListService";

/** Alta y edición de tramos de DATA AG ganadería; el resultado reemplaza la fila del listado. */
export class CostoGanaderiaSaveService extends ServiceSaveBase<CostoGanaderiaResponse, CostoGanaderiaPayload> {
  static readonly instance = new CostoGanaderiaSaveService();
  private constructor() { super(); }

  protected readonly cache = CostoGanaderiaListService.instance;

  /** gRPC-Web (`GuardarGanaderia`): sin `id` crea, con `id` edita. Precio nulo = negociación. */
  protected async sendSave(p: CostoGanaderiaPayload): Promise<CostoGanaderiaResponse> {
    const t = await grpcCall(() => grpcClient(CostosPlataformaService).guardarGanaderia({
      id: p.id ?? undefined,
      rango: p.rango,
      topeMaximoHa: p.topeMaximoHa ?? undefined,
      precioAnual: p.precioAnual !== null ? BigInt(p.precioAnual) : undefined,
      orden: p.orden,
    }));
    return toCostoGanaderiaResponse(t);
  }
}
